import './Header.css';
const Header = () => {
	return (
		<header className='header'>
			<div className='header-container'>
				<div className='user'>
					<h2 className='user-title'>Hendrick Galarza</h2>
					<p className='user-work'>Frontend developer</p>
				</div>
			</div>
		</header>
	);
};

export default Header;
